import React, { useState, useEffect } from 'react';
import styles from './Footer.module.css';

const Footer = () => {
  const [time, setTime] = useState(new Date().toLocaleTimeString());
  const [visitorCount, setVisitorCount] = useState('...');

  useEffect(() => {
    const timer = setInterval(() => {
      setTime(new Date().toLocaleTimeString());
    }, 1000);

    // Fetch and increment visitor count
    fetch('https://api.counterapi.dev/v1/princedesai012/portfolio/up')
      .then((res) => res.json())
      .then((data) => {
        if (data && data.count) {
          setVisitorCount(data.count);
        } else {
          setVisitorCount('SYS_ERR');
        }
      })
      .catch((err) => {
        console.error('Visitor Track Error:', err);
        setVisitorCount('OFFLINE');
      });

    return () => clearInterval(timer);
  }, []);

  return (
    <footer className={styles.footer}>
      <div className={styles.grid}>
        
        {/* Col 1: Status */}
        <div className={styles.statusBox}>
          <span className={styles.blink}>●</span> 
          <span>SYSTEM ONLINE</span>
        </div>

        {/* Col 2: Location/Time */}
        <div className={styles.infoBox}>
          <span>LOC: Vadodara, IN</span>
          <span className={styles.separator}>|</span>
          <span>{time}</span>
        </div>

        {/* Col 3: Tech ID */}
        <div className={styles.techBox}>
          <span>BUILD: v2.0.26</span>
          <span className={styles.separator}>|</span>
          <span>LATENCY: 24ms</span>
          <span className={styles.separator}>|</span>
          <span style={{ color: "var(--neon-cyan)", fontWeight: "bold" }}>
            VISITS: {visitorCount}
          </span>
        </div>

      </div>
      
      {/* Copyright Line (Very subtle) */}
      <div className={styles.bottomLine}>
        © {new Date().getFullYear()} Prince Desai | Engineered for Performance.
      </div>
    </footer>
  );
};

export default Footer;